import { ScoringEventEnum, ScoringEventType } from 'utils/HostMetrics';
import { z } from 'zod';

export enum PerformanceMetricEnum {
  TIMELY_RESPONSE = 'timely-response',
  GUEST_SATISFACTION = 'guest-satisfaction',
}

export const PerformanceMetricSchema = z.nativeEnum(PerformanceMetricEnum);
export type PerformanceMetric = z.infer<typeof PerformanceMetricSchema>;

export enum PerformanceTier {
  basic = 'Starter',
  bronze = 'Bronze',
  silver = 'Silver',
  gold = 'Gold',
}

export const TierKeys = Object.keys(
  PerformanceTier,
) as (keyof typeof PerformanceTier)[];

export const getPerformanceMetricByScoringEventType = (
  scoringEventType: ScoringEventType,
): PerformanceMetric => {
  switch (scoringEventType) {
    case ScoringEventEnum.IN_TIME_RESPONSE_EVENT:
      return PerformanceMetricEnum.TIMELY_RESPONSE;
    case ScoringEventEnum.REVIEW_EVENT:
      return PerformanceMetricEnum.GUEST_SATISFACTION;
  }
};
